import { FC, FocusEvent } from 'react';
import { DealerConfig } from '@services';
import { Grid } from '@mui/material';
import { FormikNumber } from '@components/common';
import { useTranslation } from 'react-i18next';

export interface IDealerFuelPriceConfigurationProps {
	config?: DealerConfig;
	onChange?: (values: Partial<DealerConfig>) => void;
}

export const DealerFuelPriceConfiguration: FC<IDealerFuelPriceConfigurationProps> = ({ config, onChange }) => {
	const { t } = useTranslation('portal');
	const onUpdateValue = (key: keyof DealerConfig, e: FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) =>
		config?.[key] !== +e.target.value && onChange?.({ [key]: +e.target.value });

	return (
		<Grid container rowSpacing={5} columnSpacing={4}>
			<Grid item xs={6}>
				<FormikNumber
					withoutFormik
					name="dieselPrice"
					title={`${t('configuration.dealer-config.fuel-price.diesel-price')} (€)`}
					fullWidth
					decimal={3}
					value={config?.dieselPrice || 0}
					onBlur={(e) => onUpdateValue('dieselPrice', e)}
				/>
			</Grid>
			<Grid item xs={6}>
				<FormikNumber
					withoutFormik
					name="gasolinePrice"
					title={`${t('configuration.dealer-config.fuel-price.gasoline-price')} (€)`}
					fullWidth
					decimal={3}
					value={config?.gasolinePrice || 0}
					onBlur={(e) => onUpdateValue('gasolinePrice', e)}
				/>
			</Grid>
			<Grid item xs={6}>
				<FormikNumber
					withoutFormik
					name="gplPrice"
					title={`${t('configuration.dealer-config.fuel-price.gpl-price')} (€)`}
					fullWidth
					decimal={3}
					value={config?.gplPrice || 0}
					onBlur={(e) => onUpdateValue('gplPrice', e)}
				/>
			</Grid>
			<Grid item xs={6}>
				<FormikNumber
					withoutFormik
					name="naturalGasPrice"
					title={`${t('configuration.dealer-config.fuel-price.natural-gas-price')} (€)`}
					fullWidth
					decimal={3}
					value={config?.naturalGasPrice || 0}
					onBlur={(e) => onUpdateValue('naturalGasPrice', e)}
				/>
			</Grid>
			<Grid item xs={6}>
				<FormikNumber
					withoutFormik
					name="electricityPrice"
					title={`${t('configuration.dealer-config.fuel-price.electricity-price')} (€)`}
					fullWidth
					decimal={3}
					value={config?.electricityPrice || 0}
					onBlur={(e) => onUpdateValue('electricityPrice', e)}
				/>
			</Grid>
			<Grid item xs={6}>
				<FormikNumber
					withoutFormik
					name="electricityHomePrice"
					title={`${t('configuration.dealer-config.fuel-price.electricity-home-price')} (€)`}
					fullWidth
					decimal={3}
					value={config?.electricityHomePrice || 0}
					onBlur={(e) => onUpdateValue('electricityHomePrice', e)}
				/>
			</Grid>
			<Grid item xs={6}>
				<FormikNumber
					withoutFormik
					name="electricitySolarPrice"
					title={`${t('configuration.dealer-config.fuel-price.electricity-solar-price')} (€)`}
					fullWidth
					decimal={3}
					value={config?.electricitySolarPrice || 0}
					onBlur={(e) => onUpdateValue('electricitySolarPrice', e)}
				/>
			</Grid>
		</Grid>
	);
};
